import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.css' // Tailwind CSS ve diğer ana stiller
import i18n from './i18n'
import router from './router'

// Swiper stilleri
// Swiper v8+ için temel stiller ve kullanılan modüllerin stilleri ayrı ayrı import edilir.
import 'swiper/css'
import 'swiper/css/autoplay' // Eğer autoplay modülünü kullanıyorsanız
import 'swiper/css/effect-fade' // Eğer EffectFade modülünü kullanıyorsanız
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// Swiper Vue bileşenlerini global olarak kaydetmek isterseniz (veya sadece ihtiyaç duyulan yerlerde import edin)
// import { Swiper, SwiperSlide } from 'swiper/vue'; // Bu satırı aktif etmeden önce `swiper` paketini kurun: npm install swiper
const app = createApp(App)

app.use(router)
app.use(i18n)

// app.component('SwiperContainer', Swiper); // Swiper'ı global yapmak için
// app.component('SwiperSlide', SwiperSlide); // SwiperSlide'ı global yapmak için

app.mount('#app')
